import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
/*import Categoria from '../components/Categoria.vue'
import Articulos from '../components/Articulo.vue'*/
import Roles from '../components/Rol.vue'
import Usuarios from '../components/Usuario.vue'
import Clientes from '../components/Cliente.vue'
import Proveedores from '../components/Proveedor.vue'
import Login from '../components/Login.vue'
/*import Ingreso from '../components/Ingreso.vue'*/
import Country from '../components/Country.vue'
import Port from '../components/Ports.vue'
import Container from '../components/Container.vue'
import Tariffs from '../components/Tariffs.vue'
import Datos from '../components/Datos.vue'
import Cotizacion from '../components/Cotizacion.vue'
import Cotizacion2 from '../components/Cotizacion2.vue'
import Prospectos from '../components/Prospectos.vue'
import Calendario from '../views/Calendario.vue'
import Calendarioejecutivos from '../views/CalendarioAdministrador.vue'
import Clausulas from '../components/Clausulas.vue'
import Bs from '../components/Bs.vue'
import Charges from '../components/Charges.vue'
import Oscar from '../components/Oscar.vue'
import Campañas from '../components/Campañas.vue'
import Scotizacion from '../components/SolicitudCotizacion.vue'
import Tarifa from '../components/Tarifa.vue'
import Bl from '../components/BL.vue'
import Inland from '../components/Inland.vue'
import uno from '../components/visorpdf.vue'
import dos from '../components/visorpdf.vue'
import visita from '../components/visita.vue'
import moneda from '../components/Monedas.vue'
import vessels from '../components/Buque.vue'
import tipocambio from '../components/tipocambio.vue'
import invoice from '../components/invoice.vue'
import visor from '../visor.vue'
import store from '../store'
import pruebacampañas from '../components/pruebacampañas.vue'
import target from '../components/target.vue'
import reportbs from '../components/ReportBS.vue'
import notificaciones from '../components/enviarNotificaciones.vue'
import industria from '../components/Industria.vue'
import facturas  from '../components/facturas.vue'
import Actividadesprueba from '../views/Actividades.vue'
import index from '../components/Logo.vue'
import pruebamsc from '../components/pruebamsc.vue'
import status from'../components/status.vue'
import tracking  from'../components/Tracking.vue'
import dashboard from '../components/Dashboard.vue'
import AddUsers from '../components/Subusuarios.vue'
import ReporteEjecutivos from '../components/ReporteEjecutivos.vue'
import relacion from '../components/relacion.vue'
import TerminosFactura from'../components/TerminosFactura.vue'


Vue.use(VueRouter)


const routes = [  
  {
    path: '/SISTEMAOPTIMAGL/home',
    //path: '/SISTEMAOGLDEMO/home',
    name: 'home',
    component: Home,
    meta:{
      administrador:true,
    /*  comercial:true,
      comercialagente:true,
      comercialadmin:true,
      pricingterrestre:true,
      pricing:true,
      finanzas:true,*/
    }
  },
  {
    path: '/TerminosFactura',
    name: 'TerminosFactura',
    component: TerminosFactura,
    meta:{
      administrador:true,
    }
  },
    {
    path: '/relacion',
    name: 'relacion',
    component: relacion,
    meta:{
      administrador:true,
      marketing:true,
    }
  },
  {
    path: '/AddUsers',
    name: 'AddUsers',
    component: AddUsers,
    meta:{
      administrador:true,
      cliente:true,
    }
  },
  {
    path: '/ReporteEjecutivos',
    name: 'ReporteEjecutivos',
    component: ReporteEjecutivos,
    meta:{
      administrador:true,
      finanzas:true,
      comercialadmin:true,
    }
  },
  {
    path: '/Tracking',
    name: 'Tracking',
    component: tracking,
    meta:{
      opcomercial:true,
      ventasfree:true,
      administrador:true,
      comercial:true,
      comercialagente:true,
      comercialadmin:true,
      pricingterrestre:true,
      pricing:true,
      operaciones:true,
      finanzas:true,
      cliente:true,
      subusuario:true,
    }
  },
  {
    path: '/Actividadesprueba',
    name: 'Actividadesprueba',
    component: Actividadesprueba,
    meta:{
      administrador:true,
     // comercial:true,
    }
  },
    {
    path: '/index',
    name: 'index',
    component: index,
    meta:{
      opcomercial:true,
      ventasfree:true,
      administrador:true,
      comercial:true,
      comercialagente:true,
      comercialadmin:true,
      pricingterrestre:true,
      pricing:true,
      operaciones:true,
      finanzas:true,
      cliente:true,
    }
  },
  {
    path: '/Industrias',
    name: 'industria',
    component: industria,
    meta:{
      administrador:true,
      marketing:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/pruebamsc',
    name: 'pruebamsc',
    component: pruebamsc,
    meta:{
      administrador:true,
      //marketing:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/facturas',
    name: 'facturas',
    component: facturas,
    meta:{
      administrador:true,
      finanzas:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Notificaciones',
    name: 'notificaciones',
    component: notificaciones,
    meta:{
      administrador:true,
      //marketing:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Dashboard',
    name: 'dashboard',
    component: dashboard,
    meta:{
      administrador:true,
      finanzas:true,
      marketing:true,
    }
  },
  {
    path: '/Report BS',
    name: 'reportbs',
    component: reportbs,
    meta:{
      opcomercial:true,
      administrador:true,
      marketing:true,
      comercial:true,
      comercialadmin:true,
      pricingagente:true,
      finanzas:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/target',
    name: 'target',
    component: target,
    meta:{
      administrador:true,
      marketing:true,
      comercial:true,
      comercialadmin:true,
      pricingagente:true,
      opcomercial:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/CapañasOgl',
    name: 'pruebacampañas',
    component: pruebacampañas,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/visor',
    name: 'visor',
    component: visor,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Tipo de Cambio',
    name: 'tipocambio',
    component: tipocambio,
    meta:{
      administrador:true,
      finanzas:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Charges references',
    name: 'invoice',
    component: invoice,
    meta:{
      administrador:true,
      finanzas:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Vessels',
    name: 'vessels',
    component: vessels,
    meta:{
      administrador:true,
      operaciones:true,
      finanzas:true,
      opcomercial:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/moneda',
    name: 'moneda',
    component: moneda,
    meta:{
      administrador:true,
      finanzas:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Visita',
    name: 'visita',
    component: visita,
    meta:{
      administrador:true,
      //comercial:true
      //libre:true
    }
  },
  {
    path: '/Actividades-Ejecutivos',
    name: 'Calendarioejecutivos',
    component: Calendarioejecutivos,
    meta:{
      administrador:true,
      //comercial:true,
      comercialadmin:true,
      marketing:true,
      //pricingterrestre:true,
      //pricing:true,
      finanzas:true,
      //pricingagente:true
    }
  },
  {
    path: '/Actividades',
    name: 'calendario',
    component: Calendario,
    meta:{
      opcomercial:true,
      ventasfree:true,
      administrador:true,
      comercial:true,
      comercialagente:true,
      comercialadmin:true,
      pricingterrestre:true,
      pricingagente:true,
      pricing:true,
      finanzas:true,
      marketing:true,
      telemarketing:true,
      //pricingagente:true
    }
  },
  {
    path: '/dos',
    name: 'dos',
    component: dos,
    meta:{
      administrador:true,
      //almacenero:true 
     // libre:true
    }
  },
  {
    path: '/uno',
    name: 'uno',
    component: uno,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Inland',
    name: 'inland',
    component: Inland,
    meta:{
      administrador:true,
      operaciones:true,
      finanzas:true,
      opcomercial:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/BL',
    name: 'bl',
    component: Bl,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Tarifa',
    name: 'tarifa',
    component: Tarifa,
    meta:{
      administrador:true,
      pricingterrestre:true,
      pricing:true,
      pricingagente:true,
      finanzas:true,
      operaciones:true,
      opcomercial:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Campañas',
    name: 'campañas',
    component: Campañas,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Scotizacion',
    name: 'scotizacion',
    component: Scotizacion,
    meta:{
      ventasfree:true,
      administrador:true,
      pricingterrestre:true,
      pricing:true,
      pricingagente:true,
      comercial:true,
      comercialagente:true,
      comercialadmin:true,
      finanzas:true,
      marketing:true,
      telemarketing:true,
      opcomercial:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Oscar',
    name: 'oscar',
    component: Oscar,
    meta:{
      administrador:true,
      operaciones:true,
      finanzas:true,
      opcomercial:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Charges',
    name: 'charges',
    component: Charges,
    meta:{
      administrador:true,
      finanzas:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Clausulas',
    name: 'clausulas',
    component: Clausulas,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
  {
    path: '/Buy and Sell',
    name: 'Bs',
    component: Bs,
    meta:{
      administrador:true,
      operaciones:true,
      comercial:true,
      comercialagente:true,
      comercialadmin:true,
      pricingterrestre:true,
      pricing:true,
      pricingagente:true,
      comercialagente:true,
      finanzas:true,
      marketing:true,
      telemarketing:true,
      opcomercial:true,
      //almacenero:true 
      //libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/country',
    name: 'country',
    component: Country,
    meta:{
      administrador:true,
      marketing:true,
      finanzas:true,
      //almacenero:true 
      //libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/port',
    name: 'port',
    component: Port,
    meta:{
      administrador:true,
      finanzas:true,
      marketing:true,
      //almacenero:true 
      //libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/container',
    name: 'container',
    component: Container,
    meta:{
      administrador:true,
      //almacenero:true 
     // libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/tariffs',
    name: 'tariffs',
    component: Tariffs,
    meta:{
      administrador:true,
      //almacenero:true 
     // libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/datos',
    name: 'datos',
    component: Datos,
    meta:{
      administrador:true,
      finanzas:true,
      marketing:true,
      //almacenero:true 
      //libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/cotizacion',
    name: 'cotizacion',
    component: Cotizacion,
    meta:{
      ventasfree:true,
      administrador:true,
      comercial:true,
      finanzas:true,
      comercialagente:true,
      comercialadmin:true,
      pricingagente:true,
      marketing:true,
      telemarketing:true,
      opcomercial:true,
      //almacenero:true 
      //libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/cotizacion2',
    name: 'cotizacion2',
    component: Cotizacion2,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
 /* {//agregamos la ruta categorias
    path: '/categorias',
    name: 'categorias',
    component: Categoria,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
   {//agregamos la ruta categorias
    path: '/articulos',
    name: 'articulos',
    component: Articulos,
    meta:{
      administrador:true,
      //almacenero:true 
     // libre:true
    }
  },*/
  /*{//agregamos la ruta categorias
    path: '/ingresos',
    name: 'ingresos',
    component: Ingreso,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },*/
   {//agregamos la ruta categorias
    path: '/roles',
    name: 'roles',
    component: Roles,
    meta:{
      administrador:true,
      //almacenero:true 
      //libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/usuarios',
    name: 'usuarios',
    component: Usuarios,
    meta:{
      administrador:true,
      //almacenero:true 
     //libre:true
    }
  },
   {//agregamos la ruta categorias
    path: '/clientes',
    name: 'clientes',
    component: Clientes,
    meta:{
      administrador:true,
      marketing:true,
      //almacenero:true 
      //libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/proveedores',
    name: 'proveedores',
    component: Proveedores,
    meta:{
      administrador:true,
      marketing:true,
      //almacenero:true 
      //libre:true
    }
  },
  {//agregamos la ruta categorias
    path: '/prospectos',
    name: 'prospectos',
    component: Prospectos,
    meta:{
      ventasfree:true,
      administrador:true,
      marketing:true,
      comercial:true,
      comercialagente:true,
      comercialadmin:true,
      pricingterrestre:true,
      pricing:true,
      pricingagente:true,
      finanzas:true,
      telemarketing:true,
      opcomercial:true,
      //almacenero:true 
      //libre:true
    }
  },
  {//agregamos la ruta categorias
    //path: '/SISTEMAOGLDEMO',
    path: '/SISTEMAOPTIMAGL',
    name: 'login', 
    component: Login,
    meta:{
      libre:true
    }
  },
  {//agregamos la ruta categorias
   //path: '/SISTEMAOGLDEMO',
   path: '/SISTEMAOPTIMAGL',
   name: 'status', 
   component: status,
   meta:{
     libre:true
   }
 }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.libre)){
    next()
  } else if(store.state.usuario && store.state.usuario.rol == 'Administrador'){
    if(to.matched.some(record => record.meta.administrador)){
      next()
    }
  }else if(store.state.usuario && store.state.usuario.rol == 'Comercial'){
    if(to.matched.some(record => record.meta.comercial)){
      next()
    }
  }else if(store.state.usuario && store.state.usuario.rol == 'ComercialAgente'){
    if(to.matched.some(record => record.meta.comercialagente)){
      next()
    }
  }else if(store.state.usuario && store.state.usuario.rol == 'Marketing'){
    if(to.matched.some(record => record.meta.marketing)){
      next()
    }
  }else if(store.state.usuario && store.state.usuario.rol == 'PricingTerrestre'){
    if(to.matched.some(record => record.meta.pricingterrestre)){
      next()
    }
  }else if(store.state.usuario && store.state.usuario.rol == 'Pricing'){
    if(to.matched.some(record => record.meta.pricing)){
      next()
    }
  }else if(store.state.usuario && store.state.usuario.rol == 'PricingAgente'){
    if(to.matched.some(record => record.meta.pricingagente)){
      next()
    }
  }
  else if(store.state.usuario && store.state.usuario.rol == 'Operaciones'){
    if(to.matched.some(record => record.meta.operaciones)){
      next()
    }
  }
  else if(store.state.usuario && store.state.usuario.rol == 'Finanzas'){
    if(to.matched.some(record => record.meta.finanzas)){
      next()
    }
  }
  else if(store.state.usuario && store.state.usuario.rol == 'VentasFree'){
    if(to.matched.some(record => record.meta.ventasfree)){
      next()
    }
  }
  else if(store.state.usuario && store.state.usuario.rol == 'Subusuario'){
    if(to.matched.some(record => record.meta.subusuario)){
      next()
    }
  }
  else if(store.state.usuario && store.state.usuario.rol == 'Cliente'){
    if(to.matched.some(record => record.meta.cliente)){
      next()
    }
  }
  else if(store.state.usuario && store.state.usuario.rol == 'ComercialAdmin'){
    if(to.matched.some(record => record.meta.comercialadmin)){
      next()
    }
  }
  else if(store.state.usuario && store.state.usuario.rol == 'Telemarketing'){
    if(to.matched.some(record => record.meta.telemarketing)){
      next()
    }
  }
  else if(store.state.usuario && store.state.usuario.rol == 'OpComercial'){
    if(to.matched.some(record => record.meta.opcomercial)){
      next()
    }
  }
  else{
    next({
      name:'login'
    })
  }
})

export default router
